module.exports = __webpack_public_path__ + "img/banner03.99a6dc92.jpg";